import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewAndCheckoutActionBox',
  props: {
    title: null,
    iconName: null,
    disabled: { type: Boolean },
    buttonText: null,
    description: null
  },
  emits: ["update-amount"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update-amount', usageLimit: number): void }), expose: any, slots: any, attrs: any }) {




return { __sfc: true,emit }
}

})